import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysHomeRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    // Fetch all data in parallel using the available service methods
    // Uses fetchDashboardDataWithLive to merge live employee data where available
    const [
      dashboardData,
      score,
      financialSnapshot,
      dataSourceInfo,
      employerContributions,
      pslfData,
      tasData,
    ] = await Promise.all([
      this.reimaginedData.fetchDashboardDataWithLive(),
      this.reimaginedData.fetchCareerCapitalScore(),
      this.reimaginedData.fetchFinancialSnapshot(),
      this.reimaginedData.getDataSourceInfo(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.fetchPslfData(),
      this.reimaginedData.fetchTasData(),
    ]);

    return {
      employee: dashboardData.employee,
      careerPlan: dashboardData.careerPlan,
      recommendations: dashboardData.recommendations,
      summary: dashboardData.summary,
      score,
      financialSnapshot,
      dataSourceInfo,
      employerContributions,
      pslfData,
      tasData,
      isLiveData: dashboardData.isLiveData,
    };
  }
}
